module.exports = __webpack_public_path__ + "img/live_02.4f53ce77.png";